<div class="m-auto">
    <p class="px-5 pt-4" *ngIf="artifact?.description" [innerHTML]="artifact.description"></p>
    <div class="m-5">
        <button mat-stroked-button color="accent" class="w-100" (click)="download(artifact)">Download</button>
    </div>
</div>
